// // import { useState, useRef } from "react";
// // import Grid from "@mui/material/Grid";
// // import CircularProgress from "@mui/material/CircularProgress";
// // import LinearProgress from "@mui/material/LinearProgress";
// // import Typography from "@mui/material/Typography";
// // import MDBox from "components/MDBox";
// // import MDInput from "components/MDInput";


// // import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// // import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// // import Footer from "examples/Footer";



// // import SimpleOpenLayersMap from "./cachementMap";
// // import VehicleList from "./VehicleList";

// // function CachementDashboard() {
// //   const [loading, setLoading] = useState(false);
// //   const [progress, setProgress] = useState(0);


// //   if (loading) {
// //     return (
// //       <DashboardLayout>
// //         <DashboardNavbar />
// //         <MDBox
// //           display="flex"
// //           flexDirection="column"
// //           alignItems="center"
// //           justifyContent="center"
// //           height="80vh"
// //         >
// //           <CircularProgress size={60} />
// //           <MDBox mt={3} width="50%">
// //             <LinearProgress variant="determinate" value={progress} />
// //           </MDBox>
// //           <Typography variant="h6" mt={2}>
// //             {progress}% loaded...
// //           </Typography>
// //         </MDBox>

// //       </DashboardLayout>
// //     );
// //   }

// //   return (
// //     <DashboardLayout>
// //       <DashboardNavbar />
// //       <MDBox>
// //         <Grid container spacing={3}>
// //           {/* Left side - Vehicles */}
// //           <Grid item xs={12} md={4} lg={5}>
// //             <Grid container spacing={3}>

// //               <Grid item xs={12}>
// //                 <VehicleList/>
// //               </Grid>
// //             </Grid>
// //           </Grid>

// //           {/* Right side - Map */}
// //           <Grid item xs={12} md={8} lg={7}>
// //             <SimpleOpenLayersMap/>
// //           </Grid>
// //         </Grid>
// //       </MDBox>

// //     </DashboardLayout>
// //   );
// // }

// // export default CachementDashboard;
// import { useState } from "react";
// import Grid from "@mui/material/Grid";
// import CircularProgress from "@mui/material/CircularProgress";
// import LinearProgress from "@mui/material/LinearProgress";
// import Typography from "@mui/material/Typography";
// import MDBox from "components/MDBox";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import SimpleOpenLayersMap from "./cachementMap";
// import VehicleList from "./VehicleList";

// function CachementDashboard() {
//   const [loading, setLoading] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [journeys, setJourneys] = useState([]);
//   const [selectedJourneys, setSelectedJourneys] = useState({});

//   const handleJourneysChange = (newJourneys, newSelectedJourneys) => {
//     setJourneys(newJourneys);
//     setSelectedJourneys(newSelectedJourneys);
//   };

//   if (loading) {
//     return (
//       <DashboardLayout>
//         <DashboardNavbar />
//         <MDBox
//           display="flex"
//           flexDirection="column"
//           alignItems="center"
//           justifyContent="center"
//           height="80vh"
//         >
//           <CircularProgress size={60} />
//           <MDBox mt={3} width="50%">
//             <LinearProgress variant="determinate" value={progress} />
//           </MDBox>
//           <Typography variant="h6" mt={2}>
//             {progress}% loaded...
//           </Typography>
//         </MDBox>
//       </DashboardLayout>
//     );
//   }

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox>
//         <Grid container spacing={3}>
//           {/* Left side - Vehicles */}
//           <Grid item xs={12} md={4} lg={5}>
//             <Grid container spacing={3}>
//               <Grid item xs={12}>
//                 <VehicleList onJourneysChange={handleJourneysChange} />
//               </Grid>
//             </Grid>
//           </Grid>

//           {/* Right side - Map */}
//           <Grid item xs={12} md={8} lg={7}>
//             <SimpleOpenLayersMap journeys={journeys} selectedJourneys={selectedJourneys} />
//           </Grid>
//         </Grid>
//       </MDBox>
//     </DashboardLayout>
//   );
// }

// export default CachementDashboard;
import { useState } from "react";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SimpleOpenLayersMap from "./cachementMap";
import VehicleList from "./VehicleList";
import MDTypography from "components/MDTypography";

function CachementDashboard() {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [journeys, setJourneys] = useState([]);
  const [selectedJourneys, setSelectedJourneys] = useState({});

  const handleJourneysChange = (newJourneys, newSelectedJourneys) => {
    setJourneys(newJourneys);
    setSelectedJourneys(newSelectedJourneys);
  };

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="80vh"
        >
          <CircularProgress size={60} />
          <MDBox mt={3} width="50%">
            <LinearProgress variant="determinate" value={progress} />
          </MDBox>
          <Typography variant="h6" mt={2}>
            {progress}% loaded...
          </Typography>
        </MDBox>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <Grid container spacing={3}>
          {/* Left side - Vehicles */}
          <Grid item xs={12} md={4} lg={5}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <VehicleList onJourneysChange={handleJourneysChange} />
              </Grid>
            </Grid>
          </Grid>

          {/* Right side - Map and Journey Details */}
          <Grid item xs={12} md={8} lg={7}>
            <Grid container direction="column" spacing={3}>
              <Grid item xs={12}>
                <SimpleOpenLayersMap journeys={journeys} selectedJourneys={selectedJourneys} />
              </Grid>
              {Object.keys(selectedJourneys).some((id) => selectedJourneys[id]) && (
  <Grid item xs={12}>
    <MDBox
      sx={{
        maxHeight: '200px', // Adjustable height
        overflowY: 'auto', // Enable vertical scrolling
        border: '1px solid #ddd',
        borderRadius: '4px',
        padding: '10px',
        backgroundColor: '#f9f9f9',
      }}
    >
      {Object.keys(selectedJourneys)
        .filter((id) => selectedJourneys[id])
        .map((journeyId) => {
          const journey = journeys.find((j) => j.journeyId === journeyId);
          if (!journey) return null;
          return (
            <MDBox key={journeyId} mb={2}>
              <MDTypography variant="h6" fontWeight="medium">
                {journey.journeyName} {journey.type} ({journey.interval.startTime}-{journey.interval.endTime})
              </MDTypography>
              <MDTypography variant="button" fontWeight="medium">Stops:</MDTypography>
              <ul style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}>
                {journey.stopPoints.map((stop, index) => (
                  <li key={index}>
                    <MDTypography variant="body2">
                      {index + 1}: {stop.locationName}
                    </MDTypography>
                  </li>
                ))}
              </ul>
            </MDBox>
          );
        })}
    </MDBox>
  </Grid>
)}
              {/* <Grid item xs={12}>
                <MDBox
                  sx={{
                    maxHeight: '200px', // Adjustable height
                    overflowY: 'auto', // Enable vertical scrolling
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    padding: '10px',
                    backgroundColor: '#f9f9f9',
                  }}
                >
                  {Object.keys(selectedJourneys)
                    .filter((id) => selectedJourneys[id])
                    .map((journeyId) => {
                      const journey = journeys.find((j) => j.journeyId === journeyId);
                      if (!journey) return null;
                      return (
                        <MDBox key={journeyId} mb={2}>
                          <MDTypography variant="h6" fontWeight="medium"
                          >
                            {journey.journeyName} {journey.type} ({journey.interval.startTime}-{journey.interval.endTime})
                          </MDTypography>
                          <MDTypography variant="button" fontWeight="medium">Stops:</MDTypography>
                         
                         <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                            {journey.stopPoints.map((stop, index) => (
                              <li key={index}>
                                <MDTypography variant="body2">
                                  {index + 1}: {stop.locationName}
                                </MDTypography>
                              </li>
                            ))}
                          </ul>
                        </MDBox>
                      );
                    })}
                </MDBox>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default CachementDashboard;
